import Vue from "vue";

/**
 * @author wdl
 * @Date 2022/6/7
 **/
import { Polygon } from "ol/geom";

export default class Convert {
    constructor(options) {
        for (let option in options) {
            this[option] = options[option];
        }
        this.hightFeature = null;
    }

    //vue 转html
    convertVueToHtml(template, dynamicTemplates, props) {
        let { tzApi } = this.mapElement;
        let tipComponent = Vue.extend({
            render: (h) =>
                h(template, {
                    props: {
                        tzApi: tzApi,
                        templateName: dynamicTemplates,
                        props: props,
                    }, //组件传值
                }),
        }); //生成组件的dom
        let component = new tipComponent().$mount();
        return component.$el;
    }

    //弹窗
    tipComponent($dom, coordinates, isPopu) {
        let { tzApi } = this.mapElement;
        try {
            let popupId = "popup-info";
            if (!isPopu) {
                tzApi.removePopup(popupId);
                return;
            } else {
                tzApi.addPopup(
                    $dom,
                    coordinates,
                    popupId, {
                    popupClass: "default",
                    closeBox: true,
                    positioning: "center",
                },
                    true
                );
            }
        } catch (e) { }
    }

    //注册移动弹窗事件
    asyncMove(listener) {
        let { tzApi } = this.mapElement;
        this.self.$eventBus.on("addPointermoveCallBack", () => {
            listener();
        });
        this.self.$eventBus.on("removePointermoveListener", () => {
            tzApi.removePointermoveListener();
        });
    }

    //高亮
    highlight(feature, callback) {
        // 事件
        let clearHightFeature = () => {
            if (this.hightFeature) {
                callback(this.hightFeature, false);
                this.hightFeature = null;
            }
        };
        let setHightFeature = () => {
            callback(feature, true);
            this.hightFeature = feature;
        };
        clearHightFeature();
        if (feature) {
            setHightFeature();
        } else {
            clearHightFeature();
        }
    }
    toGeoJson(data, json, filed = [], proj = "4326") {
        let map = new Map(),
            features = [];
        if (Array.isArray(data)) {
            for (let item in data) {
                let properties = {};
                if(!Array.isArray(filed)){
                    properties=filed
                }else{
                    filed.forEach((f) => {
                        properties[f] = data[item][f];
                    });
                }
              
                let feature = {
                    type: "Feature",
                    properties: properties,
                    geometry: data[item][json],
                };
                features.push(feature);
            }
        } else if (data instanceof Object) {
            let properties = {};
            if(filed instanceof Object){
                properties=filed
            }else{
                filed.forEach((f) => {
                    properties[f] = data[f];
                });
            }
           
            let feature = {
                type: "Feature",
                properties: properties,
                geometry: data[json],
            };
            features.push(feature);
        }
        map.set("type", "FeatureCollection");
        map.set("crs", {
            type: "name",
            properties: {
                name: `EPSG:${proj}`,
            },
        });

        map.set("features", features);
        // console.log([...map.entries()].reduce((obj, [key, value]) => (obj[key] = value, obj), {}))
        return [...map.entries()].reduce(
            (obj, [key, value]) => ((obj[key] = value), obj), {}
        );
    }
}
